import { Modal, ModalBody, Spinner } from 'reactstrap';
import Button from '../ui/Button';

interface IActionModalProps {
  isOpen: boolean;
  toggle: () => void;
  submitHandler: () => void;
  isLoading: boolean;
  title: string;
  message: string;
  icon?: React.ReactNode;
  btnText: string;
  btnClass: string;
  iconClass?: string;
}

const ActionModal = ({
  isOpen,
  toggle,
  submitHandler,
  isLoading,
  title,
  message,
  // icon,
  btnText,
  btnClass,
  // iconClass = 'icon-g'
}: IActionModalProps) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalBody className="text-center ">
        <div className="d-flex flex-column justify-items-center align-items-center gap-4">
          <span
            className="icon"
            style={{ backgroundColor: '#0047ab', boxShadow: 'none' }}
          >
            {/* {icon} */}

            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="28"
              height="28"
              x="0"
              y="0"
              viewBox="0 0 100 100"
              xmlSpace="preserve"
            >
              <g>
                <path
                  d="M98 50c0 26.467-21.533 48-48 48S2 76.467 2 50c0-1.658 1.342-3 3-3s3 1.342 3 3c0 23.159 18.841 42 42 42s42-18.841 42-42S73.159 8 50 8c-11.163 0-21.526 4.339-29.322 12H32c1.658 0 3 1.342 3 3s-1.342 3-3 3H14c-1.658 0-3-1.342-3-3V5c0-1.658 1.342-3 3-3s3 1.342 3 3v10.234C25.851 6.786 37.481 2 50 2c26.467 0 48 21.533 48 48zM77 38v27c0 1.251-.776 2.37-1.945 2.81l-24 9a3.04 3.04 0 0 1-2.11 0l-24-9A3.003 3.003 0 0 1 23 65V38c0-1.251.776-2.37 1.945-2.81l24-9a3.036 3.036 0 0 1 2.109 0l24 9A3.002 3.002 0 0 1 77 38zm-42.457 0L50 43.795 65.457 38 50 32.205zM29 62.92l18 6.75V49.08l-18-6.75zm42 0V42.33l-18 6.75v20.59z"
                  fill="#ffffff"
                  opacity="1"
                  data-original="#ffffff"
                ></path>
              </g>
            </svg>
          </span>
          <div className="d-flex flex-column gap-2">
            <h2 className="h4 mb-0">{title}</h2>
            <p className="text-muted mb-0">{message}</p>
          </div>

          <div className="row m-0 w-100 mt-2">
            <div className="col-12 col-md-6 ps-0 pe-3">
              <button
                type="button"
                className="btn btn-danger w-100"
                onClick={toggle}
              >
                Cancel
              </button>
            </div>
            <div className="col-12 col-md-6 pe-0 ps-3">
              <Button
                className={`btn btn-primary ${btnClass} w-100 `}
                onClick={submitHandler}
                disabled={isLoading}
                type="button"
              >
                {isLoading ? <Spinner color="light" size="sm" /> : btnText}
              </Button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ActionModal;
